import Link from '@tiptap/extension-link';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { selectionInRestrictedInlineLinkContext } from '../lib/post_editor_paragraph_style.js';
import { stripRestrictedInlineLinks } from '../lib/post_editor_inline_marks.js';

const restrictedLinkStripKey = new PluginKey('pathstoneRestrictedLinkStrip');

export const PathstoneLink = Link.extend({
  addCommands() {
    const parentCommands = this.parent?.();

    return {
      ...parentCommands,
      setLink:
        (attributes) =>
        (props) => {
          if (selectionInRestrictedInlineLinkContext(props.state)) return false;
          return parentCommands?.setLink?.(attributes)?.(props) ?? false;
        },
      toggleLink:
        (attributes) =>
        (props) => {
          const { editor, state } = props;
          if (selectionInRestrictedInlineLinkContext(state) && !editor.isActive(this.name)) {
            return false;
          }
          return parentCommands?.toggleLink?.(attributes)?.(props) ?? false;
        },
    };
  },

  onCreate() {
    const { editor } = this;
    const { state } = editor;
    const tr = state.tr;
    if (stripRestrictedInlineLinks(tr, state.doc, state.schema)) {
      editor.view.dispatch(tr);
    }
  },

  addProseMirrorPlugins() {
    return [
      ...(this.parent?.() ?? []),
      new Plugin({
        key: restrictedLinkStripKey,
        appendTransaction(transactions, _oldState, newState) {
          if (!transactions.some((tr) => tr.docChanged)) return null;
          const tr = newState.tr;
          if (!stripRestrictedInlineLinks(tr, tr.doc, newState.schema)) return null;
          return tr;
        },
      }),
    ];
  },
});
